import axios from 'axios';
import {
  UPDATE_CANCEL_EMAIL_PERMISSION_REQUEST,
  UPDATE_CANCEL_EMAIL_PERMISSION_SUCCESS,
  UPDATE_CANCEL_EMAIL_PERMISSION_FAILURE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { getChannel } from 'Utils/channel';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const cancelEmailPermissions = externalCustomerId => async dispatch => {

  try {
    dispatch({
      type: UPDATE_CANCEL_EMAIL_PERMISSION_REQUEST
    });


    const url = (`${API_GATEWAY}/contact-permissions/marketing/cancel-email-permission?extId=` + externalCustomerId);

    const res = await axios({
      url,
      data: { externalCustomerId },
      method: 'PUT',
      headers: {
        channel: getChannel()
      }
    });

    dispatch({
      type: UPDATE_CANCEL_EMAIL_PERMISSION_SUCCESS,
      payload: res?.data
    });

  } catch (e) {
    dispatch({
      type: UPDATE_CANCEL_EMAIL_PERMISSION_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
